export default __webpack_public_path__ + "static/Novonordisk-8a4574ae4b096a06ea8cb2d3f2d35435.jpg";